import { Component, ojs, payload, app } from "modular-openscriptjs";
import { dom, tool } from "../../fotastart";
import { cleanDispose, either, eParse, inform, isMobile } from "../../helpers";
import ProfilePic from "../ProfilePic";
import { _UNIQUE_ID_, STRINGS } from "../../declarations";
import TextArea from "../Blocks/TextArea";
import OffcanvasBody from "../Offcanvas/OffcanvasBody";
import ModalBody from "../Modals/ModalBody";

ojs(ProfilePic, TextArea, OffcanvasBody, ModalBody);

const h = app("h");
const gc = app("gc");
const broker = app("broker");
const $e = app("$e");

export default class ProductCommentForm extends Component {
	holder = null;
	button = null;

	render(product, ...args) {
		let user = product.owner;
		let id = `pcf-id-${_UNIQUE_ID_}`;

		return h.div(
			{ class: "d-flex flex-column" },

			// Header with Close Button and Title
			h.div(
				{
					class: "d-flex align-items-center justify-content-between mb-4",
				},
				h.h5({ class: "fw-bold m-0" }, "Add Comment"),
				h.button({
					type: "button",
					class: "btn-close",
					aria_label: "Close",
					onclick: this.method("closeForm"),
				})
			),

			// User & Context Info
			h.div(
				{
					class: "d-flex gap-3 align-items-center mb-4 p-3 bg-light rounded-4",
				},
				// Avatar
				h.div(
					{ class: "flex-shrink-0" },
					h.ProfilePic(gc.user, {
						class: "rounded-circle border border-2 border-white shadow-sm",
						style: "width: 48px; height: 48px; object-fit: cover;",
					})
				),
				// Info
				h.div(
					{ class: "d-flex flex-column" },
					h.div(
						{ class: "d-flex align-items-center gap-2" },
						h.span(
							{ class: "fw-bold text-dark" },
							gc.user?.value?.display_name
						),
						either(gc.user?.value?.is_verified, () =>
							h.i({
								class: "fas fa-check-circle text-primary small",
							})
						)
					),
					h.div(
						{
							class: "text-secondary small d-flex align-items-center gap-1",
						},
						"Replying to",
						h.span(
							{
								class: "fw-bold text-dark text-truncate",
								style: "max-width: 150px;",
							},
							product.name
						)
					)
				)
			),

			// Input Area
			h.div(
				{ class: "mb-4" },
				h.TextArea({
					class: "form-control border-0 bg-light-subtle rounded-4 p-3 fs-5 shadow-inner",
					style: "min-height: 120px; resize: none;",
					placeholder: "What are your thoughts?",
					pfc_hook: id,
					notice_mentions: true,
					notice_hashtags: true,
					listeners: {
						input: function () {
							let value = this.textContent;
							if (value.length <= 400) return;
							inform(
								`Limit exceeded. Will be truncated`,
								STRINGS.WARNING
							);
						},
					},
				}),
				h.div(
					{ class: "d-flex justify-content-end mt-2" },
					h.span({ class: "text-muted fs-xsm" }, "Max 400 characters")
				)
			),

			// Actions Footer
			h.div(
				{ class: "d-flex justify-content-end gap-3 pt-2" },
				h.button(
					{
						class: "btn btn-light rounded-pill px-4 fw-bold text-secondary",
						onclick: this.method("closeForm"),
					},
					"Cancel"
				),
				h.button(
					{
						class: "btn btn-primary rounded-pill px-4 fw-bold shadow-sm d-flex align-items-center gap-2",
						onclick: this.method("submitComment", [
							id,
							product,
							"${this}",
						]),
					},
					h.span("Post Comment"),
					h.i({ class: "fas fa-paper-plane" })
				)
			),

			...args
		);
	}

	$$product = {
		needs: {
			commentForm: (ed, event) => this.showForm(ed, event),
		},

		is: {
			commented: (ed, event) => {
				this.closeForm();
			},
		},

		has: {
			commentError: (ed, event) => {
				dom.put("Post Comment", this.button);
				dom.enable(this.button);
			},
		},
	};

	async showForm(ed, event) {
		if (this.holder) {
			cleanDispose(this.holder);
		}

		let data = eParse(ed);
		const product = data.message.get("product", 0);

		if (isMobile()) {
			this.holder = tool.offcanvas(
				h.OffcanvasBody(h.ProductCommentForm(product))
			);
		} else {
			this.holder = tool.plainModal(
				h.ModalBody(h.ProductCommentForm(product))
			);
		}

		this.holder.show();
	}

	closeForm() {
		this.holder?.hide();
	}

	submitComment(hook, product, button) {
		this.button = button;
		dom.disable(this.button);

		h.Spinner({ parent: this.button, resetParent: true });

		let input = dom.get(`[pfc-hook="${hook}"]`);
		let comment = input?.methods()?.value();
		broker.send(
			$e.product.needs.to.saveComment,
			payload({ product, comment })
		);
	}
}
